import client from "./httpClient";
import * as apiConstants from "../constants/Api";
const baseUrl = `${apiConstants.SERVER_URL}/csrf-service`;

export const fetchNewCsrfCookie = async () => {
  return await client.get(`${baseUrl}/token`);
};
